import { Message } from './message';

export class TopicMessage extends Message {
  Topic: string;
}
